/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Camera_RearInputs */

const th_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกกล้องหลังเป็นหลัก`)
};

const en_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rear camera (preferred)`)
};

const ja_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背面カメラを優先`)
};

const zh_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后置摄像头（首选）`)
};

const es_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cámara trasera (preferida)`)
};

const pt_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câmera traseira (preferida)`)
};

const id_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera belakang (disukai)`)
};

const fr_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caméra arrière (préférée)`)
};

const tl_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera sa likod (mas nais)`)
};

const vi_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy ảnh sau (ưu tiên)`)
};

const ko_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`후면 카메라 (선호)`)
};

const de_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückkamera (bevorzugt)`)
};

const ru_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основная камера (предпочтительно)`)
};

const tr_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arka kamera (tercihen)`)
};

const it_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotocamera posteriore (preferita)`)
};

const pl_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera tylna (preferowana)`)
};

const uk_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основна камера (бажано)`)
};

const hi_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पीछे का कैमरा (वरीयता)`)
};

const ar_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكاميرا الخلفية (مفضّلة)`)
};

const ms_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera belakang (diutamakan)`)
};

const bn_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পেছনের ক্যামেরা (পছন্দের)`)
};

const zh_tw2_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後置相機（偏好）`)
};

const zh_hk2_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後置相機（偏好）`)
};

const ur_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پچھلا کیمرا (ترجیحی)`)
};

const fa_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوربین پشت (ترجیحی)`)
};

const sw_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera ya nyuma (inapendelewa)`)
};

const nl_video_camera_rear = /** @type {(inputs: Video_Camera_RearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera aan de achterkant (voorkeur)`)
};

/**
* | output |
* | --- |
* | "Rear camera (preferred)" |
*
* @param {Video_Camera_RearInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_camera_rear = /** @type {((inputs?: Video_Camera_RearInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Camera_RearInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_camera_rear(inputs)
	if (locale === "ja") return ja_video_camera_rear(inputs)
	if (locale === "zh") return zh_video_camera_rear(inputs)
	if (locale === "es") return es_video_camera_rear(inputs)
	if (locale === "pt") return pt_video_camera_rear(inputs)
	if (locale === "id") return id_video_camera_rear(inputs)
	if (locale === "fr") return fr_video_camera_rear(inputs)
	if (locale === "tl") return tl_video_camera_rear(inputs)
	if (locale === "vi") return vi_video_camera_rear(inputs)
	if (locale === "ko") return ko_video_camera_rear(inputs)
	if (locale === "de") return de_video_camera_rear(inputs)
	if (locale === "ru") return ru_video_camera_rear(inputs)
	if (locale === "tr") return tr_video_camera_rear(inputs)
	if (locale === "it") return it_video_camera_rear(inputs)
	if (locale === "pl") return pl_video_camera_rear(inputs)
	if (locale === "uk") return uk_video_camera_rear(inputs)
	if (locale === "hi") return hi_video_camera_rear(inputs)
	if (locale === "ar") return ar_video_camera_rear(inputs)
	if (locale === "ms") return ms_video_camera_rear(inputs)
	if (locale === "bn") return bn_video_camera_rear(inputs)
	if (locale === "zh-TW") return zh_tw2_video_camera_rear(inputs)
	if (locale === "zh-HK") return zh_hk2_video_camera_rear(inputs)
	if (locale === "ur") return ur_video_camera_rear(inputs)
	if (locale === "fa") return fa_video_camera_rear(inputs)
	if (locale === "sw") return sw_video_camera_rear(inputs)
	if (locale === "nl") return nl_video_camera_rear(inputs)
	return en_video_camera_rear(inputs)
});